import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createGraphqlWsClient } from "./graphqlWsClient";

const wsClient = createGraphqlWsClient({
  wsEnvUrl: process.env.REACT_APP_WS_BFF_URL,
  httpEnvUrl: process.env.REACT_APP_REST_BFF_URL,
});

const wsLink = wsClient ? new GraphQLWsLink(wsClient) : null;

export default wsLink;
